import { AllowedMediaFileExtensionsEnum } from 'dash-common';

export const ViewedFileTypes = [
  AllowedMediaFileExtensionsEnum.svg,
  AllowedMediaFileExtensionsEnum.png,
  AllowedMediaFileExtensionsEnum.jpg,
  AllowedMediaFileExtensionsEnum.jpeg,
  AllowedMediaFileExtensionsEnum.avi,
  AllowedMediaFileExtensionsEnum.mov,
  AllowedMediaFileExtensionsEnum.mp4,
  AllowedMediaFileExtensionsEnum.webp,
];
